//csgo 商城暗金
// 商城的暗金与奖品的暗金 值与文字不是对应的
const shopType = [{
		type: 1,
		text: '普通'
	},
	{
		type: 2,
		text: 'StatTrak™'
	},
	{
		type: 3,
		text: '纪念品'
	},
	{
		type: 4,
		text: '★'
	},
	{
		type: 5,
		text: '★StatTrak™'
	}
]
export default shopType
